export default __webpack_public_path__ + "static/media/politica-de-control-interno.7c1a81cc.pdf";